// extracted by mini-css-extract-plugin
export var banner = "_lm-0";
export var settingRow = "_lm-2";
export var titleIcon = "_lm-1";